var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RoundedButton',{staticClass:"back",on:{"click":_vm.back}},[_c('i',{staticClass:"fa-solid fa-arrow-left fa-xs"}),_c('span',{staticStyle:{"margin-left":"8px"}},[_vm._v(_vm._s(_vm.$t('common.back')))])])}
var staticRenderFns = []

export { render, staticRenderFns }